module.exports = __webpack_public_path__ + "img/top-merit-2.c292fce8.jpg";